// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/force_reload.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * ForceReload構造体
 *
 * @generated from message entity.ForceReload
 */
export class ForceReload extends Message<ForceReload> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: google.protobuf.Timestamp force_reload_date = 3 [json_name = "force_reload_date"];
   */
  forceReloadDate?: Timestamp;

  /**
   * @generated from field: bool is_ios = 4 [json_name = "is_ios"];
   */
  isIos = false;

  /**
   * @generated from field: bool is_android = 5 [json_name = "is_android"];
   */
  isAndroid = false;

  /**
   * @generated from field: string environment = 6;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 7 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 8 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 9;
   */
  version = "";

  constructor(data?: PartialMessage<ForceReload>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.ForceReload";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "force_reload_date", jsonName: "force_reload_date", kind: "message", T: Timestamp },
    { no: 4, name: "is_ios", jsonName: "is_ios", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_android", jsonName: "is_android", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 8, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 9, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ForceReload {
    return new ForceReload().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ForceReload {
    return new ForceReload().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ForceReload {
    return new ForceReload().fromJsonString(jsonString, options);
  }

  static equals(a: ForceReload | PlainMessage<ForceReload> | undefined, b: ForceReload | PlainMessage<ForceReload> | undefined): boolean {
    return proto3.util.equals(ForceReload, a, b);
  }
}

